import { Component, Input, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Modal } from '../modal';
import { Document, DocumentFile, Enterprise, User } from '../../models/models';
import { DataService } from '../../services/data.service';
import { SelectItemInterface } from '../../components/select/select.component';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DocumentService } from '../../services/document.service';
import { AuthService } from '../../services/auth.service';
import { DocumentManagerComponent } from '../../components/document-manager/document-manager.component';

@Component({
  selector: 'app-document-create-modal',
  templateUrl: './document-create-modal.component.html',
  styleUrls: ['./document-create-modal.component.scss'],
})
export class DocumentCreateModalComponent extends Modal {
  @Input() document: Document;
  enterprises: Enterprise[];
  enterprisesValues: SelectItemInterface[];
  loading = false;
  user: User;
  documentForm: FormGroup = new FormGroup({
    title: new FormControl(null, [Validators.required]),
    toBeCompleted: new FormControl(false),
    file: new FormGroup({
      name: new FormControl(null, [Validators.required]),
      data: new FormControl(null),
    }),
  });

  constructor(
    modalCtrl: ModalController,
    private documentService: DocumentService,
    public authService: AuthService
  ) {
    super(modalCtrl);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.authService.user.subscribe((user) => {
      this.user = user;
    });
    if (this.document) {
      this.documentForm.patchValue({
        title: this.document.title,
        toBeCompleted: this.document.toBeCompleted,
        file: {
          name: this.document.fileName,
          data: null,
        },
      });
    }
  }

  validate() {
    if (!this.documentForm.valid) {
      this.documentForm.markAllAsTouched();
      return;
    }
    this.loading = true;
    const data = this.documentForm.value;
    data.addToLibrary = true;
    if (this.document) {
      this.documentService
        .updateDocument(this.document.uuid, data)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
            this.close({ confirm: true });
          }, 1000);
        })
        .catch((res) => {
          this.loading = false;
        });
    } else {
      this.documentService
        .createDocument(data)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
            this.close({ confirm: true });
          }, 1000);
        })
        .catch((res) => {
          this.loading = false;
        });
    }
  }
}
